import React from "react";
import parse from "html-react-parser";
import { motion } from "framer-motion";
import Spacing from "../Spacing";

export default function SectionHeading({
  title = "",
  titleUp = "",
  titleDown = "",
  subTitle = "",
  center,
}) {
  const words = title.split(" ").filter(Boolean);

  return (
    <div
      className={`cs_section_heading cs_style_1 ${
        center ? "text-center" : ""
      }`}
    >
      {titleUp && (
        <>
          <h3 className="cs_section_subtitle text-uppercase cs_accent_color cs_semibold m-0 cs_fs_32">
            {parse(titleUp)}
          </h3>
          <Spacing md="5" />
        </>
      )}

      {title && (
        <h2 className="cs_section_title cs_fs_72 m-0">
          {words.map((word, i) => (
            <motion.span
              key={i}
              initial={{
                opacity: 0,
                y: 30,
                filter: "blur(12px)",
              }}
              whileInView={{
                opacity: 1,
                y: 0,
                filter: "blur(0px)",
              }}
              viewport={{
                once: true,
                amount: 0.4,
              }}
              transition={{
                duration: 0.8,
                delay: i * 0.08,
                ease: [0.16, 1, 0.3, 1],
              }}
              style={{
                display: "inline-block",
                willChange: "transform, opacity, filter",
              }}
            >
              {parse(word)}
              {i !== words.length - 1 && "\u00A0"}
            </motion.span>
          ))}
        </h2>
      )}

      {titleDown && (
        <>
          <Spacing md="5" />
          <h3 className="cs_section_subtitle text-uppercase cs_accent_color cs_semibold m-0 cs_fs_32">
            {parse(titleDown)}
          </h3>
        </>
      )}

      {subTitle && (
        <>
          <Spacing md="25" />
          <p className="m-0">{parse(subTitle)}</p>
        </>
      )}
    </div>
  );
}